<template>
  <div class="grid grid-cols-14 bg-[#12131B] py-2">
    <div
      v-if="$q.screen.gt.sm"
      class="col-span-2"
    />
    <div class="col-span-14 px-5 md:(col-span-10 px-2) flex flex-nowrap items-center gap-10">
      <QIcon
        name="campaign"
        color="secondary"
        size="20px"
      />
      <Vue3SeamlessScroll
        :list="announcementStore.news"
        direction="left"
        hover
        :limit-scroll-num="1"
        single-line
        class="overflow-hidden"
      >
        <div
          v-for="item in announcementStore.news"
          class="px-10 md:px-20 flex items-center gap-10"
        >
          {{ item.title }}
        </div>
      </Vue3SeamlessScroll>
    </div>
  </div>
</template>

<script setup>
import { Vue3SeamlessScroll } from "vue3-seamless-scroll"
import { useAnnouncementStore } from '@/stores/announcement.js'

const announcementStore = useAnnouncementStore()
announcementStore.fetchNews()
</script>
